import React from "react";
import PropTypes from "prop-types";
import t from "../../utils/translation/translator";

const Navigator = ({
  previousAction,
  continueAction,
  continueLabel,
  cancelAction,
  continueButtonDisabled,
  rounded,
  ...props
}) => (
  <div
    className={`Navigator flex p-2 justify-center space-x-5 absolute bottom-0 bg-white border-t left-0 w-full drop-shadow-xl hover:drop-shadow-2xl transition-all duration-75 z-10
  ${rounded ? "rounded-b-md" : ""}`}
    {...props}
  >
    {cancelAction && (
      <qds-button id="naviguator-button-cancel" onClick={cancelAction} text={t("msizer.ui.footer.cancel")}></qds-button>
    )}

    {previousAction && (
      <qds-button
        id="naviguator-button-previous"
        onClick={previousAction}
        icon-name="chevron-left"
        text={t("msizer.ui.footer.previous")}
      ></qds-button>
    )}
    {continueAction && (
      <qds-button
        id="naviguator-button-continue"
        importance="emphasized"
        onClick={continueAction}
        {...(continueButtonDisabled ? { disabled: "" } : {})}
        text={continueLabel || t("msizer.ui.footer.continue")}
      ></qds-button>
    )}
  </div>
);

Navigator.propTypes = {
  previousAction: PropTypes.func,
  continueAction: PropTypes.func,
  continueLabel: PropTypes.string,
  cancelAction: PropTypes.func,
  continueButtonDisabled: PropTypes.bool
};

Navigator.defaultProps = {
  previousAction: undefined,
  continueAction: undefined,
  continueLabel: undefined,
  cancelAction: undefined,
  continueButtonDisabled: false
};

export default Navigator;
